export default __webpack_public_path__ + "static/media/85193418-6704-4f40-9fee-26e363f7d9ac.b65571d9.jpg";